import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Applicationdetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.APPLICATIONDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.APPLICATIONDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.APPLICATIONDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}